import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
    BuyerDocumentKind,
    IBuyer,
    IBuyerAttachment,
    IBuyerPage,
    ICreateBuyerRequest,
    IUpdateBuyerRequest,
} from '../interfaces/garments/buyer.interface';

const headers = () => AuthService.getAuthHeader();

export const BuyerService = {
    list: async (
        institutionId: string,
        page = 0,
        size = 20,
        search?: string,
        activeOnly = false
    ): Promise<IBuyerPage> => {
        const res = await axios.get(ENDPOINTS.BUYER.LIST(institutionId), {
            headers: headers(),
            params: { page, size, search, activeOnly },
        });
        return res.data;
    },

    getById: async (institutionId: string, id: string): Promise<IBuyer> => {
        const res = await axios.get(ENDPOINTS.BUYER.GET(institutionId, id), { headers: headers() });
        return res.data;
    },

    create: async (institutionId: string, request: ICreateBuyerRequest): Promise<IBuyer> => {
        const res = await axios.post(ENDPOINTS.BUYER.CREATE(institutionId), request, { headers: headers() });
        return res.data;
    },

    update: async (institutionId: string, id: string, request: IUpdateBuyerRequest): Promise<IBuyer> => {
        const res = await axios.put(ENDPOINTS.BUYER.UPDATE(institutionId, id), request, { headers: headers() });
        return res.data;
    },

    activate: async (institutionId: string, id: string): Promise<IBuyer> => {
        const res = await axios.patch(ENDPOINTS.BUYER.ACTIVATE(institutionId, id), null, { headers: headers() });
        return res.data;
    },

    deactivate: async (institutionId: string, id: string): Promise<IBuyer> => {
        const res = await axios.patch(ENDPOINTS.BUYER.DEACTIVATE(institutionId, id), null, { headers: headers() });
        return res.data;
    },

    uploadBuyerAttachment: async (
        institutionId: string,
        buyerId: string,
        file: File,
        documentKind: BuyerDocumentKind
    ): Promise<IBuyerAttachment> => {
        const formData = new FormData();
        formData.append('file', file);
        const res = await axios.post(ENDPOINTS.BUYER.UPLOAD_ATTACHMENT(institutionId, buyerId), formData, {
            headers: { ...headers(), 'Content-Type': 'multipart/form-data' },
            params: { documentKind },
        });
        return res.data;
    },

    listBuyerAttachments: async (institutionId: string, buyerId: string): Promise<IBuyerAttachment[]> => {
        const res = await axios.get(ENDPOINTS.BUYER.LIST_ATTACHMENTS(institutionId, buyerId), { headers: headers() });
        return res.data;
    },

    downloadBuyerAttachment: async (institutionId: string, buyerId: string, attachmentId: string): Promise<Blob> => {
        const res = await axios.get(ENDPOINTS.BUYER.DOWNLOAD_ATTACHMENT(institutionId, buyerId, attachmentId), {
            headers: headers(),
            responseType: 'blob',
        });
        return res.data;
    },

    deleteBuyerAttachment: async (institutionId: string, buyerId: string, attachmentId: string): Promise<void> => {
        await axios.delete(ENDPOINTS.BUYER.DELETE_ATTACHMENT(institutionId, buyerId, attachmentId), { headers: headers() });
    },
};
